import axios from 'axios';

const API_BASE = '/api/material-takeoffs';

export const materialTakeoffService = {
  list: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  get: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (payload) => {
    const response = await axios.post(API_BASE, payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await axios.patch(`${API_BASE}/${id}`, payload);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  analyze: async (id) => {
    const response = await axios.post(`${API_BASE}/${id}/analyze`);
    return response.data;
  },

  getJob: async (jobId) => {
    const response = await axios.get(`${API_BASE}/jobs/${jobId}`);
    return response.data;
  },

  retryJob: async (jobId) => {
    const response = await axios.post(`${API_BASE}/jobs/${jobId}/retry`);
    return response.data;
  },

  saveBuyItems: async (id, items) => {
    const response = await axios.put(`${API_BASE}/${id}/buy-items`, { items });
    return response.data;
  },

  applyToQuote: async (id, itemIds = null) => {
    const response = await axios.post(`${API_BASE}/${id}/apply-to-quote`, {
      item_ids: itemIds || [],
    });
    return response.data;
  },
};

export function isAnalyzableAttachment(attachment) {
  if (!attachment) return false;
  const ct = String(attachment.content_type || '').toLowerCase();
  const name = String(attachment.file_name || '').toLowerCase();
  if (ct.includes('pdf') || /\.pdf$/i.test(name)) return true;
  if (ct.startsWith('image/') || /\.(png|jpe?g|gif|webp)$/i.test(name)) return true;
  return false;
}

export function jobStatusLabel(status) {
  switch (status) {
    case 'queued': return 'Queued';
    case 'processing': return 'Analyzing…';
    case 'completed': return 'Ready';
    case 'failed': return 'Failed';
    case 'cancelled': return 'Cancelled';
    default: return status || '—';
  }
}

export function jobStatusColor(status) {
  switch (status) {
    case 'queued': return 'default';
    case 'processing': return 'info';
    case 'completed': return 'success';
    case 'failed': return 'error';
    default: return 'default';
  }
}

export function takeoffStatusLabel(status) {
  switch (status) {
    case 'draft': return 'Draft';
    case 'review': return 'Review';
    case 'approved': return 'Approved';
    case 'superseded': return 'Superseded';
    default: return status || '—';
  }
}

export function takeoffStatusColor(status) {
  switch (status) {
    case 'draft': return 'default';
    case 'review': return 'warning';
    case 'approved': return 'success';
    case 'superseded': return 'default';
    default: return 'default';
  }
}
